/**
 * Unsaved edits of item rows, kept while the user moves between tabs.
 * A row stores its draft when it has unsaved changes and clears it on Save or Cancel, so a draft only
 * survives a remount (such as a tab switch) for as long as the edits are still unsaved.
 */
const drafts = new Map<string, object>();

export const getStagedDraft = <T extends object>(key: string): T | undefined => drafts.get(key) as T | undefined;

export const setStagedDraft = (key: string, draft: object): void => {
  drafts.set(key, { ...draft });
};

export const clearStagedDraft = (key: string): void => {
  drafts.delete(key);
};
